<template>
  <div>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="delinquents"
        :page.sync="page"
        :items-per-page="delinquentsPerPage"
        :server-items-length="totalDelinquents"
        hide-default-footer
        :single-select="singleSelect"
        show-select
        @page-count="pageCount = $event"
        sort-by="name"
        class="elevation-1 ml-4"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
          <v-col
            cols="12"
            sm="3"
          >
          <v-select
            :items="allDistricts"
            item-text="name"
            item-value="id"
            v-model="residenceId"
            dense
            outlined
            color="grey"
            hint="Filter by District"
            persistent-hint
            class="mt-8 mx-4"
            solo
          />
          </v-col>
          <v-col
            cols="12"
            sm="3"
          >
          <v-text-field
            v-model="delinquentFirstName"
            dense
            outlined
            color="grey"
            hint="Filter by Name"
            persistent-hint
            class="mt-8 mx-4"
            solo
          />
          </v-col>
          <v-btn
            class="mt-2"
            elevation="1"
            fab
            small
            @click="loadAllDelinquents"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn rounded disabled right>{{currentCenter.name}}</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.names="{ item }">
          <p @click="loadProfile(item)" class=" btn blue--text">{{ item.names }}</p>
        </template>
      </v-data-table>
      <v-card class="ml-4 mt-1">
        <v-row>
        <v-col
          cols="12"
          sm="2"
        >
        <v-btn class="green ml-4 mt-4" dense @click="releasingDialog()">Confirm Release</v-btn>
        </v-col>
        <v-dialog v-model="releaseDialog" hide-overlay max-width="430px" persistent>
          <v-card tile outlined>
              <v-card-text>
                <v-menu
                  ref="releaseDateMenu"
                  v-model="releaseDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="formattedReleaseDate"
                      label="Transfer Date"
                      outlined
                      filled
                      color="grey"
                      dense
                      v-if="selectDate"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="releaseDate"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    no-title
                    @change="saveReleaseDate"
                  ></v-date-picker>
                </v-menu>
                <p v-if="!selectDate">Are you sure you want to submit selected delinquents?</p>
                <v-btn link small color="blue" @click="selectDate = false" v-if="selectDate">Ok</v-btn>
                <v-btn link small color="blue" @click="releaseDialog = false" v-if="selectDate">Cancel</v-btn>
                <v-btn link small color="blue" @click="releaseGraduates" v-if="!selectDate">Yes</v-btn>
                <v-btn link small color="blue" @click="releaseDialog = false" v-if="!selectDate">No</v-btn>
              </v-card-text>
            </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="2">
          <p class="mx-4">{{selected.length}} Selected </p>
        </v-col>
        </v-row>
        </v-card>
        <div class="pt-2 px-12">
        <v-row>
        <v-col cols="12" sm="2">
        <v-select
          :items="selectDelinquentsPerPage"
          v-model="delinquentsPerPage"
          label="Delinquents per page"
          dense
        ></v-select>
        </v-col>
        <v-col cols="12" sm="8">
        <v-pagination
          v-model="page"
          :length="pageCount"
          circle
          total-visible="7"
          color="blue"
        ></v-pagination>
        </v-col>
        <v-col cols="12" sm="2">
          {{totalDelinquents}} Records
        </v-col>
        </v-row>
      </div>
  <v-snackbar
      v-model="snackbar"
      top
      :color="color"
      :timeout="timeout"
    >
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          icon
          v-bind="attrs"
          @click="setSnackbar(false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- <v-dialog v-model="addDialog" hide-overlay max-width="500px">
    <v-card tile outlined>
        <v-card-text>
          <p>You are about to add {{selected.length}} delinquents to graduation list. Continue ?</p>
          <v-btn link small color="blue" @click="releaseGraduates()">Yes</v-btn>
          <v-btn link small color="blue" @click="addDialog = false">No</v-btn>
        </v-card-text>
      </v-card>
  </v-dialog> -->
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data () {
    return {
      dialog: false,
      privileges: null,
      showCreate: false,
      addDialog: false,
      names: null,
      selectDate: true,
      releaseDialog: false,
      disableRequest: false,
      headers: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'number'
        },
        { text: 'Names', value: 'names' },
        { text: 'Year Of Birth', value: 'delinquent.dateOfBirth' },
        { text: 'Intake', value: 'intakeName' },
        { text: 'Graduation', value: 'graduationName' },
        { text: 'Graduation Date', value: 'graduationDate' },
        { text: 'Destination', value: 'apprehension.delinquentResidence.district.name' },
        { text: 'Guardian Name', value: 'delinquent.guardian' },
        { text: 'Guardian Phone', value: 'delinquent.guardianPhone' }
      ],
      delinquents: [],
      trainings: [],
      selectDelinquentsPerPage: [2, 5, 10, 15, 20, 25, 30],
      page: 1,
      pageCount: 0,
      delinquentsPerPage: 20,
      totalDelinquents: 0,
      singleSelect: false,
      allDistricts: [],
      emptyDistrict: { id: null, name: '' },
      selected: [],
      transferId: null,
      errors: null,
      panel: 3,
      delinquentFirstName: null,
      delinquentLastName: null,
      placeOfBirthId: null,
      residenceId: null,
      recordDates: null,
      arrivalDates: null,
      exitDates: null,
      released: null,
      states: null,
      eligibilityStates: null,
      intakeId: null,
      intakeSet: null,
      decisionIds: null,
      physicallyScreened: null,
      screeningApprovalStatuses: null,
      onGraduationList: null,
      graduationId: null,
      expand: false,
      graduationApprovalStatuses: null,
      postRehabDestinationId: null,
      hasOccupation: null,
      organizationId: null,
      sort: 'recordDate,desc',
      releaseDate: new Date().toISOString(),
      releaseDateMenu: false
    }
  },

  computed: {
    ...mapState('store', ['snackbar', 'color', 'text', 'timeout', 'currentUser', 'currentCenter', 'search', 'storeProvinces', 'storeProvincesError', 'deviantActs', 'identificationDocuments', 'apprehensionItems']),
    formattedReleaseDate () {
      return this.releaseDate ? this.$moment(this.releaseDate).format('DD-MMM-YYYY')
        : this.retrievedReleaseDate ? this.$moment(this.retrievedReleaseDate).format('DD-MMM-YYYY')
          : ''
    }
  },

  watch: {
    page: {
      handler () {
        this.loadAllDelinquents()
      }
    },
    delinquentsPerPage: {
      handler () {
        this.page = 1
        this.loadAllDelinquents()
      }
    }
  },
  mounted () {
    this.loadAllDelinquents()
    this.privileges = this.currentUser.privileges
    this.checkPrivileges()
  },
  created () {
    this.loadAllDistricts()
  },
  destroyed () {
    this.setSnackbar(false)
  },

  methods: {
    ...mapActions('store', ['loadStoreProvinces']),
    ...mapMutations('store', {
      setSnackbar: 'SET_SNACKBAR',
      setColor: 'SET_COLOR',
      setText: 'SET_TEXT',
      setDelinquentItem: 'SET_DELINQUENT_ITEM'
    }),
    loadAllDelinquents () {
      const pageNumber = this.page - 1
      this.delinquentLastName = this.delinquentFirstName
      this.graduationApprovalStatuses = 'APPROVED'
      this.onGraduationList = true
      this.expand = true
      this.states = 'REHABILITATION'
      this.$delinquentService.fetchAllTransfersSpecification(this.delinquentFirstName, this.delinquentLastName, this.placeOfBirthId, this.residenceId, this.recordDates, this.arrivalDates, this.exitDates, this.released, this.states, this.eligibilityStates, this.intakeId, this.intakeSet, this.decisionIds, this.physicallyScreened, this.screeningApprovalStatuses, this.onGraduationList, this.graduationId, this.expand, this.graduationApprovalStatuses, this.postRehabDestinationId, this.hasOccupation, this.organizationId, pageNumber, this.delinquentsPerPage, this.sort)
        .then(response => {
          if (!response.status) {
            this.delinquents = response.content
            this.totalDelinquents = response.totalElements
            this.delinquents.forEach(element => {
              element.names = element.delinquent.firstName + ' ' + element.delinquent.lastName
              element.delinquent.dateOfBirth = this.$moment(element.delinquent.dateOfBirth).format('YYYY')
              element.arrivalDate = this.$moment(element.arrivalDate).format('DD-MMM-YYYY')
              element.number = response.content.indexOf(element) + 1
            })
          } else {
            // this.$authenticationService.checkAuthentication(response.status, this.$router, this.$store)
            this.setSnackbar(true)
            this.setColor('red')
            this.setText('Read Delinquents: ' + response.message)
          }
        })
    },
    releasingDialog () {
      if (this.selected.length > 0) {
        this.releaseDialog = true
      } else {
        this.setSnackbar(true)
        this.setColor('orange')
        this.setText('No delinquents selected')
      }
    },
    loadAllDistricts () {
      this.$locationService.fetchAllDistricts()
        .then(response => {
          if (!response.status) {
            this.allDistricts = response
            this.allDistricts.unshift(this.emptyDistrict)
          } else {
            this.setSnackbar(true)
            this.setColor('red')
            this.setText(response.message)
          }
        })
    },
    releaseGraduates () {
      const releaseObject = {
        releaseDate: this.formattedReleaseDate,
        transferIds: this.selected.map(element => element.id)
      }
      this.$delinquentService.releaseGraduates(releaseObject)
        .then(response => {
          if (response.status === 'success') {
            this.loadAllDelinquents()
            this.setSnackbar(true)
            this.setColor('green')
            this.setText('Delinquents released successfully')
            this.addDialog = false
            this.selected = []
          } else {
            this.setSnackbar(true)
            this.setColor('red')
            this.setText(response.message)
          }
          this.releaseDialog = false
        })
    },
    loadProfile (item) {
      this.setDelinquentItem(item)
      this.$router.push('/delinquent-profile')
    },
    saveReleaseDate (releaseDate) {
      this.$refs.releaseDateMenu.save(releaseDate)
    },
    checkPrivileges () {
      this.privileges.includes('CREATE_DELINQUENTS') || this.privileges.includes('ALL_AUTHORITIES') ? this.showCreate = true : this.showCreate = false
      this.privileges.includes('UPDATE_DELINQUENTS') || this.privileges.includes('ALL_AUTHORITIES') ? this.showEdit = true : this.showEdit = false
      this.privileges.includes('DELETE_DELINQUENTS') || this.privileges.includes('ALL_AUTHORITIES') ? this.showDelete = true : this.showDelete = false
    }
  }
}
</script>
<style scoped>
.btn {
  cursor: pointer;
}
</style>
